import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import type { AnalyticTag } from '@sorare/core/src/components/search/InstantSearch/types';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import type { CardPageSortName } from '@sorare/core/src/lib/algolia';
import { SaleType } from '@sorare/core/src/lib/algolia';
import type { FiltersGroup } from '@sorare/core/src/lib/filters';

import { BackendCardPageSearch } from '#src/components/market/BackendCardPageSearch/index.tsx';
import { AdvancedCardSearch } from '#src/searchCards/AdvancedCardSearch/index.tsx';

type Props = {
  sport: Sport;
  sorts: CardPageSortName[];
  defaultSort: CardPageSortName;
  defaultFilters: string[];
  analyticsTags: AnalyticTag[];
  cardFilters: FiltersGroup[];
  backendCardFilters: () => FiltersGroup[];
  topic: {
    type: 'player' | 'team' | 'league' | 'country';
    label: string;
  };
  hideStackedSwitch?: boolean;
};

export const CardPageSearch = ({
  sport,
  sorts,
  defaultSort,
  defaultFilters,
  analyticsTags,
  cardFilters,
  backendCardFilters,
  topic,
  hideStackedSwitch,
}: Props) => {
  const {
    flags: { enableGraphqlCardPages },
  } = useFeatureFlags();

  if (enableGraphqlCardPages) {
    return (
      <BackendCardPageSearch
        sport={sport}
        cardFilters={backendCardFilters()}
        defaultFilters={defaultFilters}
        sorts={sorts}
        defaultSort={defaultSort}
        topic={topic}
      />
    );
  }

  return (
    <AdvancedCardSearch
      sport={sport}
      sorts={sorts}
      defaultSort={defaultSort}
      analyticsTags={analyticsTags}
      defaultFilters={defaultFilters}
      cardFilters={cardFilters}
      stackableTypes={[SaleType.PRIMARY_OFFER]}
      hideStackedSwitch={hideStackedSwitch}
      topic={topic}
    />
  );
};
